import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/modern.css';
import { useAuth } from './context/AuthContext';
import { PageProvider } from './context/PageContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ComprehensiveDashboard from './pages/ComprehensiveDashboard';
import AdminManagement from './pages/AdminManagement';
import EmployeeManagement from './pages/EmployeeManagement';
import ClientManagement from './pages/ClientManagement';
import VendorManagement from './pages/VendorManagement';
import RecruiterManagement from './pages/RecruiterManagement';
import EnhancedInvoiceManagement from './pages/EnhancedInvoiceManagement';
import ExpenseManagement from './pages/ExpenseManagement';
import ExpenseRecipients from './pages/ExpenseRecipients';
import ExpenseAnalytics from './pages/ExpenseAnalytics';
import PaymentHistory from './pages/PaymentHistory';
import NewConditionManagement from './pages/NewConditionManagement';
import Reports from './pages/Reports';
import HowItWorks from './pages/HowItWorks';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100" style={{background: '#f8fafc'}}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mt-3">Loading Payroll System...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <PageProvider>
      <Router>
        <Layout>
        <Routes>
          <Route path="/" element={<ComprehensiveDashboard />} />
          <Route path="/dashboard" element={<ComprehensiveDashboard />} />
          <Route path="/admin" element={<AdminManagement />} />
          <Route path="/employees" element={<EmployeeManagement />} />
          <Route path="/clients" element={<ClientManagement />} />
          <Route path="/vendors" element={<VendorManagement />} />
          <Route path="/recruiters" element={<RecruiterManagement />} />

          <Route path="/invoices" element={<EnhancedInvoiceManagement />} />
          <Route path="/expenses" element={<ExpenseManagement />} />
          <Route path="/expense-recipients" element={<ExpenseRecipients />} />
          <Route path="/expense-analytics" element={<ExpenseAnalytics />} />
          <Route path="/payment-history" element={<PaymentHistory />} />
          <Route path="/payroll-conditions" element={<NewConditionManagement />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
        </Layout>
      </Router>
    </PageProvider>
  );
}

export default App;